// extracted by mini-css-extract-plugin
export default {"text":"SafetyEventTooltip_text__l4+cU"};